export const FAQ_INTRO = "Entre os dias 06 e 09 de novembro teremos um encontro com os revendedores que tiveram performances de destaque no primeiro semestre do Ano Safra 26/27. Nos dias 07 e 08 vamos celebrar juntos no lounge VIP exclusivo da Shell no Grande Prêmio de São Paulo 2026.";

export const FAQ_ITEMS = [
  {
    question: "Posso levar acompanhante para a premiação?",
    paragraphs: [
      "Para a revenda ganhadora: este ano o acompanhante terá acesso a toda a agenda do evento, incluindo autódromo e Cirque du Soleil. Para isso, precisamos da confirmação pelo site oficial do evento até o dia 16/10.",
      "Lembre-se de preencher as informações do seu acompanhante no cadastro. Só assim ele estará incluído na programação do evento.",
    ],
  },
  {
    question: "Ganhei com mais de um IBM. Quantas pessoas poderão ir ao evento?",
    paragraphs: ["Cada IBM ganhador tem direito a um par de ingressos válidos para sábado e domingo."],
  },
  {
    question: "Como funciona a minha hospedagem?",
    paragraphs: [
      "Será disponibilizada hospedagem para os ganhadores de fora da cidade de São Paulo entre os dias 06 e 09 de novembro.",
      "Em breve você receberá mais detalhes sobre a sua hospedagem.",
    ],
    items: ["Check-in no dia 06/11, a partir das 14h.", "Checkout no dia 09/11, até as 12h."],
  },
  {
    question: "Como faço para garantir minha passagem aérea?",
    paragraphs: ["A compra da passagem aérea é de responsabilidade dos ganhadores. Atente-se ao horário de chegada, pois o check-in no hotel será realizado a partir das 14h."],
  },
  {
    question: "Posso comprar ingresso para o lounge VIP na arquibancada da Shell?",
    paragraphs: ["Não existe venda de ingresso para o lounge VIP. Esse espaço é destinado apenas aos ganhadores do Desafio F1."],
  },
  {
    question: "Os ingressos da arquibancada Shell dão acesso ao lounge VIP?",
    paragraphs: ["Os ingressos da arquibancada Shell, disponibilizados por meio de ações do Shell Box, não dão acesso ao lounge VIP. O revendedor ganhador poderá acessar a arquibancada."],
  },
  {
    question: "Terei ingresso para o Cirque du Soleil?",
    paragraphs: [
      "Para complementar o seu fim de semana, convidamos você e seu acompanhante para assistir ao espetáculo do Cirque du Soleil, patrocinado oficialmente pela Shell.",
      "O acesso ao espaço VIP do Cirque inicia às 18h30, e o espetáculo acontecerá no sábado, dia 07 de novembro, a partir das 20h. Para sua comodidade, teremos transfer hotel > espetáculo > hotel.",
      "Recomendamos fortemente que as pessoas que optarem por ir ao espetáculo voltem do autódromo ao hotel nos primeiros transfers. Por isso, deverão sair do autódromo, no máximo, às 15h. Acesse a agenda completa do evento para conferir a programação.",
    ],
  },
  {
    question: "Vou receber um kit para o evento?",
    paragraphs: ["Ao fazer o credenciamento, o ganhador e seu acompanhante receberão um kit. Ele incluirá, entre outros itens, pulseira de identificação para uso durante todo o evento, um par de ingressos para o Grande Prêmio de São Paulo 2026, nos dias 07 e 08 de novembro, e camisa para uso no autódromo."],
  },
  {
    question: "Onde farei a retirada do kit e o credenciamento?",
    paragraphs: [
      "Para todos os ganhadores, o credenciamento acontecerá no Wyndham São Paulo Ibirapuera Convention Plaza Hotel, na Avenida Ibirapuera, 2927, Moema, São Paulo, na sexta-feira, 06 de novembro, das 9h às 19h, e no sábado, 07 de novembro, das 8h às 9h30.",
    ],
  },
  {
    question: "Terei transfer durante o evento?",
    paragraphs: ["Sim. Disponibilizaremos transfer para toda a agenda do evento. O evento não contempla transfer entre aeroporto e hotel."],
  },
  {
    question: "Sou da cidade de São Paulo. Terei transfer para o autódromo?",
    paragraphs: ["Sim. A partir do Wyndham São Paulo Ibirapuera Convention Plaza Hotel, você poderá utilizar os traslados para o autódromo e o espetáculo."],
  },
  {
    question: "Não estou recebendo as comunicações do evento. Como posso resolver?",
    paragraphs: ["Uma série de comunicações importantes sobre o evento está sendo enviada para toda a base de ganhadores. Caso você não esteja recebendo ou queira cadastrar outro e-mail, entre em contato pelo e-mail contato@desfiopes2026.com.br."],
  },
  {
    question: "Qual é o traje recomendado para o autódromo?",
    paragraphs: [
      "Os ganhadores receberão camisas polo para utilização nos dois dias do evento, para identificação e entrada no lounge VIP. Recomendamos a utilização de protetor solar e sapatos confortáveis.",
      "Nossa arquibancada é coberta, mas temos áreas de passagem abertas. Atente-se à previsão do tempo antes do evento.",
    ],
  },
  {
    question: "O que posso levar para o autódromo?",
    paragraphs: ["Caso leve bolsa, sacola ou mochila, dê preferência a itens de pequeno porte, devido às restrições de entrada da F1 e ao fato de não haver guarda-volumes no evento."],
  },
  {
    question: "Menores de idade podem entrar no autódromo?",
    paragraphs: ["Proibida a entrada de menores de 5 anos de idade.  A idade minima para entrada no GP é 5 anos completos."],
  },
];
